/* src/app/support/service-log/service-log.component.css */
.service-log-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  max-width: 500px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}
h2 {
  margin-top: 0;
  font-size: 22px;
  font-weight: 500;
}
.add-note-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}
.note-input {
  width: 100%;
}
.notes-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.note-item {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 10px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  position: relative;
}
.note-author {
  font-size: 12px;
  color: #555;
  margin-bottom: 4px;
}
.delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
}
.note-date {
  font-size: 12px;
  color: #888;
  margin-bottom: 4px;
}
.note-text {
  font-size: 15px;
  color: #222;
}
.empty-log {
  color: #aaa;
  text-align: center;
  margin-top: 16px;
}
.tab-content {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}
/*# sourceMappingURL=service-log.component.css.map */
